<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button data-test="menuButton" auto-hide="false"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title">Accounts</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="refreshButton" (click)="onRefresh()">
                <ion-icon name="refresh-outline"></ion-icon>
            </ion-button>
            <ion-button data-test="addButton" (click)="onAddAccountClick()">
                <ion-icon name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-searchbar data-test="searchBar" (ionInput)="getSubset($event)"></ion-searchbar>

    <ion-list>
        @for (header of headers; track $index) {
        <ion-item-sliding>
            <ion-item (click)="onAccountClick(header.uid)">
                <ion-label class="ion-text-wrap">
                    <span class="line1">{{header.accountNumber}}</span><br />
                    <span class="line1">{{header.dealershipName}}</span>
                </ion-label>
            </ion-item>

            <ion-item-options>
                <ion-button data-test="deleteButton" color="danger"
                    (click)="onDeleteAccountClick(header.accountNumber, header.dealershipName)">
                    <ion-icon name="trash"></ion-icon>
                    Delete Account
                </ion-button>
            </ion-item-options>
        </ion-item-sliding>
        }
    </ion-list>
</ion-content>